import { DataTable } from 'primereact/datatable';
import { Filters } from './filters/ServiceShareFilters';
import { useServiceShareInput } from './hooks/useServiceShareInput';
import { Column } from 'primereact/column';
import { nameof } from '../../shared/utility';
import { IServiceShareInputSearchResponseModel } from '../../models/serviceShareInput/ServiceShareInputSearchResponseModel';
import Pagination from '../common/pagination/Pagination';
import { useServiceShareInputPagination } from './hooks/useServiceShareInputPagination';
import { EditServiceShareInput } from './edit/components/EditServiceShareInputButton';
import { IServiceShareInputFiltersOptions } from '../../models/serviceShareInput/ServiceShareFiltersModel';

export const ServiceShareInput = () => {
	const {
		isLoading,
		serviceShareInputs,
		filtersControl,
		filtersValues,
		handlePageChange,
		triggerRefetch,
		clearFilters,
		searchDistributors
	} = useServiceShareInput();

	const { first, rows } = useServiceShareInputPagination(
		serviceShareInputs?.page ?? 1,
		10
	);

	return (
		<>
			<Filters
				control={filtersControl}
				triggerRefetch={triggerRefetch}
				clearFilters={clearFilters}
				searchDistributors={searchDistributors}
			/>
			<DataTable
				value={serviceShareInputs?.models}
				responsiveLayout='scroll'
				// sortField={sortField}
				// sortOrder={sortOrder}
				// onSort={onSort}
				loading={isLoading}
			>
				<Column
					sortable
					header='Period'
					field={nameof<IServiceShareInputSearchResponseModel>(
						'period'
					)}
				/>

				<Column
					sortable
					header='Distributor/Entity'
					field={nameof<IServiceShareInputSearchResponseModel>(
						'distributorOrEntity'
					)}
					style={{ padding: '10px 15px 10px 10px' }}
				/>

				<Column
					sortable
					header='Brand'
					field={nameof<IServiceShareInputSearchResponseModel>(
						'brandDescription'
					)}
					style={{ padding: '10px 15px 10px 10px' }}
				/>

				<Column
					sortable
					header='Channel'
					field={nameof<IServiceShareInputSearchResponseModel>(
						'channel'
					)}
					style={{ padding: '10px 15px 10px 10px' }}
				/>

				<Column
					sortable
					header='№ of Employees'
					field={nameof<IServiceShareInputSearchResponseModel>(
						'numberOfEmployees'
					)}
					style={{ padding: '10px 15px 10px 10px' }}
				/>

				<Column
					sortable
					header='№ Technicians'
					field={nameof<IServiceShareInputSearchResponseModel>(
						'numberOfTechnicians'
					)}
					style={{ padding: '10px 15px 10px 10px' }}
				/>

				<Column
					sortable
					header='Fridge Technicians'
					field={nameof<IServiceShareInputSearchResponseModel>(
						'fridgeTechnicians'
					)}
					style={{ padding: '10px 15px 10px 10px' }}
				/>

				<Column
					body={(rowData: IServiceShareInputSearchResponseModel) => {
						return (
							<EditServiceShareInput
								id={rowData.id}
								dropdownsOptions={
									filtersValues.filterValuesOptions as IServiceShareInputFiltersOptions
								}
								triggerRefetch={triggerRefetch}
							/>
						);
					}}
				/>
			</DataTable>

			<Pagination
				totalRecords={serviceShareInputs?.total}
				rows={rows}
				first={first}
				onPageChange={handlePageChange}
			/>
		</>
	);
};
